const cardDiv = document.querySelector('#b2bCard');
const htmlDIV = cardDiv.querySelector('div[name=locationsBody]');
// const typeDisplay = document.querySelector('#b2bDocsParntersCimena').querySelector('div[name=body]');
// import auth from '../tools/storage.js';

import tools from '../../tools/tools.js';

export default {

  cleanContainer() {
    htmlDIV.innerHTML = '';
  },


  drawDataInContainer(data, cardUploads) {

    // htmlDIV.innerHTML = `
    // <div class="reference-header">
    //     <div class="reference-column">№</div>
    //     <div class="reference-column">Ссылка:</div>
    //     <div class="reference-column">Решение:</div>
    // </div>
    // `;
    cardDiv.querySelector('b[name=totalLocations').innerHTML = 'всего: ' + data.length;
    this.cleanContainer();
    data.forEach((item, index) => htmlDIV.insertAdjacentHTML('beforeend', this.getElement(item, index, cardUploads)));
    
  },

  getElement(item, index , cardUploads) {

    let divStatus = '';
    if(parseInt(item.status) == 0) {
      divStatus = ' canceled';
    } else if(parseInt(item.status) == 2){
      divStatus = 'greenElement_';
      if(item.filmName) 
        divStatus += '1';
      if(item.reportPhoto) 
        divStatus += '1';
      if(item.reportUrl) 
        divStatus += '1';

    }


    if(cardDiv.querySelector('button[name=typeDisplayLocations]').value == 1)

      return `
        <div class="cloud-local ${divStatus}" >
          <b>${item.name}</b>
        </div>`;
    else  {
      let localBodyItem = '';

      let photoRow = '';
      // console.log(cardUploads);
      // console.log(cardUploads.filter(up => up.location == item.id));
      // console.log(item);

      if(cardUploads && cardUploads.filter(up => up.location == item.id)?.length > 0){
        photoRow += `${ cardUploads.filter(up => up.location == item.id).map(pic => `<a href="https://storage.yandexcloud.net/fest-b2b/suzdal2025/reportImages/${pic.name}" target="_blank" class="report_photo_preview_a">  
          <img src="https://storage.yandexcloud.net/fest-b2b/suzdal2025/reportImages/${pic.name}" class="report_photo_preview" />
        </a>`)}`;
      } else if(item.reportPhotoStatus == 9)
        photoRow =`<b>Заявитель указал, что на этой площадке фото не будет!!!</b>`;
        else 
        photoRow = '<b>Ожидаем фото по площадке!!!!</b>'


      if (item.status)
      {
        localBodyItem = `
          <div class="row m-0 p-0">
            <div class="w-50">
             <label class="mr-1">Реальное кол-во показов:</label>${item.realCountPlays ? ('<b>' + item.realCountPlays + '</b>') : '?'} 
            </div>
            <div class="w-50">
             <label class="mr-1">Реальное кол-во зрителей:</label>${item.realPeople ? ('<b>' + item.realPeople + '</b>') : '?'} 
            </div>
            <div class="w-100 row m-0 p-1">
             ${photoRow}
            </div
            <label class="mr-1 ml-auto">Победитель:</label>${item.filmName ? ('<b >' + item.filmName + '</b>') : '?'} 
            <div class="row m-0 p-0">
              <label class="ml-0 mr-1 ">Ссылки на публикации в СМИ:</label>  ${item.reportUrl ? ('<a href="' + item.reportUrl+ '" target="_blank">'+ item.reportUrl + '</a>'): '-'}
            </div>
          </div>

          `;

          //       localBodyItem = `
          // <div class="row m-0 p-0">
          //   <div class="w-50">
          //    <label class="mr-1">Реальное кол-во показов:</label>${item.realCountPlays ? ('<b>' + item.realCountPlays + '</b>') : '?'} 
          //   </div>
          //   <div class="w-50">
          //    <label class="mr-1">Реальное кол-во зрителей:</label>${item.realPeople ? ('<b>' + item.realPeople + '</b>') : '?'} 
          //   </div>
          //    <label class="mr-1 ml-auto">Победитель:</label>${item.filmName ? ('<b >' + item.filmName + '</b>') : '?'} 
          // </div>
          // <div class="row m-0 p-0">
          //    <label class="ml-0 mr-1 ">Ссылка на фото-отчет:</label> ${item.reportPhoto ? ('<a  href="' + item.reportPhoto+ '" target="_blank">'+ item.reportPhoto + '</a>')  : '-'}  
          // </div>
          // <div class="row m-0 p-0">
          //    <label class="ml-0 mr-1 ">Ссылки на публикации в СМИ:</label>  ${item.reportUrl ? ('<a href="' + item.reportUrl+ '" target="_blank">'+ item.reportUrl + '</a>'): '-'}
          // </div>`;
      } else 
      {
        localBodyItem = `<h4 class="red txt-al-center">Показ отменен! - ${item.status}</h4>`
      }
      return `
        <div class="cloud-local w-100 ${divStatus}_border" >
          <b>${item.name}</b>
          <div class="row m-0 p-0">${item.regionName}  -> ${item.cityName}</div>
          <div class="row m-0 p-0">${item.address}</div>
          <div class="row m-0 p-0">
             <label class="mr-1">Вместимость:</label>${item.countPeople} <label class="ml-auto mr-1 ">Планируемое кол-во показов:</label>${item.countPlays}
          </div>
          <div class="row m-0 p-0">
             <label class="mr-1">Контатные данные:</label><b class="mr-3"> ${item.contactFIO}</b> ${tools.formatedPhone('7'+item.contactPhone)}
          </div>
            ${localBodyItem}
        </div>`;
    }
    },

};

// locRealPeople smallint unsigned NULL  
// locReportScan varchar(12) NULL  
// locReportUrl
